var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: {
        "enter-active-class": "slideBounceFadeDown",
        "leave-active-class": "slideBounceFadeUp",
      },
    },
    [
      _vm.isShowing
        ? _c(
            "div",
            {
              ref: "hud",
              staticClass: "question-mark-block-hud container text-center",
              staticStyle: {
                position: "fixed",
                inset: "0 0 auto 0",
                "z-index": "var(--depth-foreground)",
                "font-size": "var(--size-reset-base)",
              },
              attrs: {
                tabindex: "-1",
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true",
                "aria-describedby": "question-mark-block-hud-instructions",
              },
            },
            [
              _c(
                "p",
                {
                  staticClass: "sr-only",
                  attrs: { id: "question-mark-block-hud-instructions" },
                },
                [
                  _vm._v("\n      Game "),
                  _c("abbr", { attrs: { title: "Heads Up Display" } }, [
                    _vm._v("H.U.D"),
                  ]),
                  _vm._v(
                    " Updated: Here's your current coin count, lives, and time.\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "hud-bar position-relative inverted display-inline-flex flex-items-center flex-content-center padding-top-lg padding-bottom-md padding-x-2xl position-relative with-shadow size-sm",
                  staticStyle: {
                    "--with-shadow-box-shadow":
                      "0 var(--with-shadow-box-shadow-width) 0 var(--fa-dk-navy)",
                    "border-end-start-radius": "var(--border-radius-lg)",
                    "border-end-end-radius": "var(--border-radius-lg)",
                    "background-color": "var(--fa-navy)",
                    gap: "var(--spacing-6xl)",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "display-flex flex-row flex-items-center",
                      staticStyle: { gap: "var(--spacing-sm)" },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticStyle: {
                          "--fa-primary-color": "var(--fa-teal)",
                          "--fa-secondary-opacity": "1",
                        },
                        attrs: {
                          icon: _vm.$v6.duotone[_vm.selectedUserIcon],
                          size: "xl",
                          "swap-opacity": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticStyle: { color: "var(--fa-dk-gravy)" },
                        attrs: { icon: _vm.$v6.solid.faXmark, size: "sm" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Current Lives: "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-family": "'Press Start'",
                            "letter-spacing": "var(--letter-spacing-xl)",
                          },
                        },
                        [_vm._v(_vm._s(_vm.oneUpCount))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "display-flex flex-row flex-items-center flex-content-center",
                      staticStyle: { gap: "var(--spacing-sm)" },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticStyle: {
                          "--fa-secondary-color": "var(--fa-yellow)",
                          "--fa-secondary-opacity": "1",
                        },
                        attrs: {
                          icon: _vm.$v6.duotone.faCoinFront,
                          size: "xl",
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticStyle: { color: "var(--fa-dk-gravy)" },
                        attrs: { icon: _vm.$v6.solid.faXmark, size: "sm" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Current Coins: "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-family": "'Press Start'",
                            "letter-spacing": "var(--letter-spacing-xl)",
                          },
                        },
                        [_vm._v(_vm._s(_vm.formattedGlobalBopCount))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "display-flex flex-row flex-items-center flex-content-center",
                      staticStyle: {
                        gap: "var(--spacing-sm)",
                        "font-family": "'Press Start'",
                        "letter-spacing": "var(--letter-spacing-xl)",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticStyle: {
                          "--fa-secondary-color": "var(--fa-brand-blue)",
                          "--fa-secondary-opacity": "1",
                        },
                        attrs: {
                          icon: _vm.$v6.duotone.faFontAwesome,
                          size: "xl",
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticStyle: { color: "var(--fa-dk-gravy)" },
                        attrs: { icon: _vm.$v6.solid.faXmark, size: "sm" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Current Font Awesome Version/World: "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-family": "'Press Start'",
                            "letter-spacing": "var(--letter-spacing-xl)",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$releases.active.versionParts.major) +
                              "-" +
                              _vm._s(_vm.$releases.active.versionParts.minor)
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "display-none tablet:display-flex flex-row flex-items-center flex-content-end",
                      staticStyle: { gap: "var(--spacing-sm)" },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticStyle: {
                          "--fa-secondary-color": "var(--fa-red)",
                          "--fa-secondary-opacity": "1",
                        },
                        attrs: { icon: _vm.$v6.duotone.faClock, size: "xl" },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticStyle: { color: "var(--fa-dk-gravy)" },
                        attrs: { icon: _vm.$v6.solid.faXmark, size: "sm" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Current Time: "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "time",
                        {
                          staticStyle: {
                            "font-family": "'Press Start'",
                            "letter-spacing": "var(--letter-spacing-xl)",
                          },
                          attrs: {
                            datetime: _vm.isoTime,
                            "aria-live": "polite",
                          },
                        },
                        [_vm._v(_vm._s(_vm.formattedTime))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }